<template>
  <form class="margin-bottom-0" method="post" action="#">
    <div class="alert alert-success" role="alert" v-show="message.success">
      {{ message.success }}
    </div>
    <div class="text-center m-t-2" v-show="message.success">
      <router-link class="btn btn-link" :to="{ name: 'Login'}">Go to Login</router-link>
    </div>
    <div v-show="!message.success">
      <div class="alert alert-danger" role="alert" v-show="message.error">
        {{ message.error }}
      </div>
      <div class="form-group m-b-15">
        <label for="password-input">Password</label>
        <input class="form-control form-control-lg" :class="{'is-invalid': $v.password.$error}" type="password" v-model.trim="password" id="password-input" @input="$v.password.$touch()" @keyup.enter="save()">
        <div v-if="$v.password.$error" :class="{'invalid-feedback': !$v.password.minLength}">Password min length is 6</div>
      </div>

      <div class="form-group m-b-15"">
        <label for="confirm-password-input">Confirm password</label>
        <input class="form-control form-control-lg" :class="{'is-invalid': $v.confirmPassword.$error}" type="password" v-model.trim="confirmPassword" id="confirm-password-input" @input="$v.confirmPassword.$touch()" @keyup.enter="save()">
        <div v-if="$v.confirmPassword.$error" :class="{'invalid-feedback': !$v.confirmPassword.sameAsPassword}">Passwords must be identical.</div>
      </div>

      <div class="login-buttons">
        <button type="submit" class="btn btn-womia btn-block btn-lg" v-on:click.stop.prevent="save()">Change password</button>
        <router-link role="button" type="cancel" class="btn btn-default btn-block btn-lg" :to="{ name: 'Profile'}">Cancel</router-link>
      </div>
    </div>
  </form>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'ResetPassword',
  mixins: [validationMixin],
  validations: {
    password: {
      required,
      minLength: minLength(6)
    },
    confirmPassword: {
      sameAsPassword: sameAs('password')
    }
  },
  data() {
    return {
      password: null,
      confirmPassword: null,
      message: {
        error: null,
        success: null
      },
      authToken: this.$route.query.authToken
    }
  },

  methods: {
    hideErrorMessage() {
      this.message.error = null
    },
    showErrorMessage(message) {
      this.message.error = message
    },
    showSuccessMessage(message) {
      this.message.success = message
    },
    save: function() {
      if (!this.$v.confirmPassword.$invalid && !this.$v.password.$invalid) {
        this.$http
          .post(
            'user/me/reset-password',
            { password: this.password },
            { params: { authToken: this.authToken } }
          )
          .then(
            () => {
              this.showSuccessMessage('Your password has been successfully changed, now you can login with the new password.')
            },
            err => {
              // error callback
              console.log(err)
            }
          )
      } else {
        console.error('Form is not valid, check before submit')
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/auth/ResetPassword.vue